// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"MenuItem_menuItem__2uhZA","activeMenuItem":"MenuItem_activeMenuItem__2A-gl"};